const styles = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: '100vh',
	},
	content: {
		flexGrow: 1,
		py: [20, 30],
	},
};

export default styles;
